export default __webpack_public_path__ + "static/media/ogc-construction-white.0fe82560.svg";